<template>
  <div class="modal-container clearfix">
    <div class="container">
      <vxe-form
          :data="formData"
          :rules="formRules"
          title-colon
          ref="xForm"
          title-width="120"
          title-align="right"
      >
        <vxe-form-item title="审核结果" field="state" span="24">
          <template>
            <vxe-radio-group v-model="formData.state">
              <vxe-radio :label="1" content="通过"></vxe-radio>
              <vxe-radio :label="0" content="驳回"></vxe-radio>
            </vxe-radio-group>
          </template>
        </vxe-form-item>
        <vxe-form-item
            title="驳回原因"
            field="info"
            span="24"
            v-if="formData.state === 0"
        >
          <template>
            <vxe-input
                v-model="formData.info"
                placeholder="请输入驳回原因"
                clearable
            ></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="是否推送" field="isPush" span="24">
          <template>
            <vxe-radio-group v-model="formData.isPush">
              <vxe-radio :label="1" content="是"></vxe-radio>
              <vxe-radio :label="0" content="否"></vxe-radio>
            </vxe-radio-group>
          </template>
        </vxe-form-item>
      </vxe-form>
    </div>
    <div class="modal-footer add-btn-box">
      <Button type="primary" @click="submit">提交</Button>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";

export default {
  name: "Message",
  props: {
    id: String
  },
  data() {
    return {
      formData: {
        state: null,
        info: null,
        isPush: 0
      },
      formRules: {
        state: [{required: true, message: "请选择审核结果"}],
        info: [{required: false, message: "请填写驳回原因"}]
      },
      value: ""
    };
  },
  watch: {
    "formData.state": {
      deep: true,
      handler(val) {
        if (val === "0") {
          this.formRules.info[0].required = true;
        }
      }
    }
  },
  methods: {
    setMessage(message) {
      this.message = message;
    },
    close() {
      this.$emit("close");
    },
    async submit() {
      const errMap = await this.$refs.xForm.validate().catch(errMap => errMap);
      if (errMap) {
        return;
      }
      let params = {
        id: this.id,
        state: Number(this.formData.state),
        info: this.formData.info,
        isPush: this.formData.isPush
      };
      let res = await $api.matchOrder.request("invoiceAudit", params);
      if (res.status === 1) {
        this.$Message.success("审核成功！");
        this.close();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
.container {
  display: flex;
  width: 100%;
}

.invoice-audit-top {
  display: block;
  width: 100%;
  height: 40px;
  border: 1px solid #f00;
  line-height: 40px;

  label {
    padding-right: 20px;
  }
}
</style>
